import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Tab, Tabs, Tooltip } from "react-bootstrap";
import OverlayTrigger from "../../components/OverlayTrigger";
import styled from "styled-components";
import ProposalForm from "../../components/ProposalForm";
import ProposalPreviewForm from "../../components/ProposalPreviewForm";
import LoginModal from "../../components/LoginModal";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProposalPreviewModal from "../../components/ProposalPreviewModal";
import useIsMobile from "../../utils/helpers/use-is-mobile";
import SubscriptionModal from "../../components/subscriptionModal";
import { useNavigate } from "react-router";
import {
  PROPOSAL_RESSET_VALUES,
  PROPOSAL_SET_VALUES,
} from "../../store/constants/proposalConstants";
import { decodeHtmlEntities, toastError, toastSuccess } from "../../utils/helpers/helper";
import {
  addPageFavorite,
  createPageView,
  fetchPageFavorite,
  removePageFavorite,
  updateUserTrade,
} from "../../store/actions/users/users.actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as regularStar } from "@fortawesome/free-regular-svg-icons";
import { useFeatureAccess } from "../../hooks/useFeatureAccess";
import RecentPaintProposal from "../../components/RecentPaintProposal";
import { downloadPaintProposal, getPaintProposalDetail, getProposalTemplates, savePaintProposal, updatePaintProposal } from "../../store/actions/paint_proposal/paint_proposal.action";
import TradeDropdown from "../../components/TradeDropdown";
import { PROFILE_DETAILS_SUCCESS } from "../../store/constants/userConstants";
import { InfoCircle } from "react-bootstrap-icons";
import EmailModal, { stripEmailTemplateMergeFields } from "../../components/emailModal";
import {
  updateContactLastDateByName,
  updateProjectContactLastDateByName,
} from "../../store/actions/projects/projects.action";
import { saveUserEditableTemplateAPI } from "../../utils/requests/userEmailTemplates";

function paintProposalRecipientMergeFirstNames(data) {
  const names = [
    data?.project_contact_1_name,
    data?.project_contact_2_name,
    data?.project_contact_3_name,
    data?.project_contact_4_name,
  ]
    .filter(Boolean)
    .map((n) => n.split(" ")[0]);
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  if (names.length > 2) return `${names.slice(0, -1).join(", ")}, and ${names.at(-1)}`;
  return "";
}

const StyledSectionTwo = styled.div`
  background-color: rgb(246 248 250);
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
`;

const StyledPreviewText = styled.h3`
  color: #000;
  font-weight: 700;
`;

const StyledTabs = styled(Tabs)`
  background-color: #fff;
  h2 {
    color: #000;
  }
  button {
    font-size: 16px !important;
    font-weight: 700 !important;
  }
  .nav-item button#noanim-tab-example-tab-new {
    color: #fff;
    background-color: #276fb4;
  }
`;

const PaintDocumentGenerator = () => {
  const isMobile = useIsMobile();
  let params = useParams();
  const { search } = window.location;
  const show_tab = new URLSearchParams(search).get("show_tab");
  let [searchParams] = useSearchParams();
  const project_type = searchParams.get("project_type");
  const { id } = params;
  const [emailModalShow, setEmailModalShow] = useState(false);
  const [proposalData, setProposalData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [paymentModalShow, setPaymentModalShow] = useState(false);
  const [proposalPreviewModal, setProposalPreviewModal] = useState(false);
  const [showTab, setShowTab] = useState("home");
  const { user } = useSelector((state) => state.auth);
  const { free_mode_count } = useSelector((state) => state.userFreeModeCount);
  const { user: profile, loading } = useSelector((state) => state.userDetails);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const proposalList = useSelector((state) => state.proposalList);
  const userEditableTemplates = useSelector((state) => state.userEditableTemplates?.list ?? []);
  const { proposals } = proposalList;
  const { proposal } = useSelector((state) => state.proposalDetail);
  const { projectTypes } = useSelector((state) => state.projectTypeList);
  const { proposalTemplates } = useSelector((state) => state.proposalTemplates);
  const values = useSelector((state) => state.proposalValues);
  const sections = useSelector((state) => state.proposalSections);
  const { error: errorForm, loading: createLoader } = useSelector(
    (state) => state.proposalCreate
  );
  const { loading: downloader } = useSelector(
    (state) => state.proposalDownload
  );
  const { hasFeatureAccess, enforceAccess } = useFeatureAccess("Paint Proposal");
  const { isFavorite, loading: fetchLoader } = useSelector(
    (state) => state.fetchPageFavorite
  );

  let proposalId;
  let proposalObject;
  if (proposals.length > 0) {
    if (id) {
      proposalId = proposal?.id;
      proposalObject = proposal;
    }
  }

  // const ganarpro_app = localStorage.getItem(`ganarpro_app${user?.id}`);
  const paint_app = profile?.trade === 'painting';

  const handleSetPaymentModalShow = (e) => {
    e.preventDefault();
    localStorage.setItem("proposal", JSON.stringify(values));
    setPaymentModalShow(true);
  };

  const showFormTab = (e) => {
    if (e === "home") {
      setShowTab("home");
    } else if (e === "recent") {
      setShowTab("recent");
    } else if (e === "new") {
      dispatch({ type: PROPOSAL_RESSET_VALUES });

      const store_template = localStorage.getItem(`template_${user?.id}`);
      let selectedTemplate = proposalTemplates.find(
        (template) => template.name.toLowerCase() === (store_template ? store_template?.toLowerCase() : "painting")
      );

      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          proposal_template: selectedTemplate.name,
          disclosure: selectedTemplate.disclosure,
          scope: selectedTemplate.scope,
          user_scope: selectedTemplate.user_scope,
          scope_name: `Project Proposal for ${selectedTemplate.name.includes("Paint") ? "Paint" : "Drywall"}`
        },
      });

      navigate("/paint_proposal");
    } else if (e === 'create_deal') {
      navigate('/create_deal')
    } else if (id !== undefined) {
      setShowTab("home");
    }
  };
  const handleDownload = (e, id, proposal) => {
    let newValues = values;

    let trueKeys = Object.keys(sections)
      .map((key) => {
        if (sections[key]) {
          return key;
        }
      })
      .filter((key) => key);

    if (user) {
      newValues = {
        ...values,
        ...profile,
        current_date: new Date().toUTCString().slice(0, 16),
      };
    }

    try {
      delete newValues['project_type']
      newValues = {
        ...newValues,
        sections: trueKeys.join(","),
      };

      if (!user.id) {
        localStorage.setItem("proposal", JSON.stringify(values));
        setModalShow(true);
      } else {
        if (id) {
          dispatch(updatePaintProposal(values?.id, newValues, true));
        } else if (!hasFeatureAccess) {
          enforceAccess();
        } else {
          dispatch(savePaintProposal(newValues, true));
        }
      }
    } catch (e) {
      toastError("Unable to download proposal");
    }
  };

  const path = global.window.location.pathname.slice(1);

  useEffect(() => {
    const pageRecord = id ? values?.project_name : "Paint Proposal";
    const type = "Paint Proposal";

    dispatch(createPageView(pageRecord, path, type));
  }, [dispatch, values?.project_name]);

  useEffect(() => {
    if (id && user) {
      dispatch(getPaintProposalDetail(id));
      // setShowTab("home");
    }
    if (show_tab) {
      setShowTab("recent");
    }

  }, [dispatch, id, show_tab, user]);

  useEffect(() => {
    if (!proposalTemplates.length)
      return;

    const store_template = localStorage.getItem(`template_${user?.id}`);
    let selectedTemplate = proposalTemplates.find(
      (template) => template.name.toLowerCase() === (store_template ? store_template?.toLowerCase() : "painting")
    );

    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        proposal_template: selectedTemplate?.name,
        user_scope: selectedTemplate?.user_scope || selectedTemplate?.scope,
        disclosure: selectedTemplate?.disclosure,
      },
    });

  },[proposalTemplates])

  const handleFavoriteToggle = () => {
    if (isFavorite) {
      dispatch(removePageFavorite({ page_name: "Paint Proposal" })); // Assuming page_url is the identifier
    } else {
      dispatch(
        addPageFavorite({ page_name: "Paint Proposal", page_url: path })
      );
    }
  };

  useEffect(() => {
    dispatch(fetchPageFavorite("Paint Proposal"));
    dispatch(getProposalTemplates());
  }, [dispatch]);

  useEffect(() => {
    if (profile?.trade !== 'painting' && profile?.trade) {
      navigate('/my_proposal');
      return
    }
  }, [profile?.trade]);

  useEffect(() => {
    if (profile?.trade !== 'painting' && profile?.trade) {
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          scope_name: profile?.last_simple_proposal_scope_name || `Construction Cleanup Proposal`
        },
      });
      return;
    } else if (profile?.trade === 'painting' && profile?.trade) {
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          scope_name: profile?.last_paint_proposal_scope_name || 'Project Proposal for Paint'
        },
      });
    }
  }, [profile?.last_paint_proposal_scope_name, profile?.last_simple_proposal_scope_name]);

  useEffect(() => {
    if (!values?.border_color) {
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: { border_color: localStorage.getItem('border_color') }
      });
    }
  }, [values?.border_color])

  const handleTradeChange = (trade) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: PROFILE_DETAILS_SUCCESS,
        payload: { ...profile, trade }
      });
      
      dispatch(updateUserTrade(trade))
        .then(() => {
          resolve();
          navigate('/my_proposal');
        })
        .catch((error) => {
          dispatch({
            type: PROFILE_DETAILS_SUCCESS,
            payload: profile
          });
          reject(error);
        });
    });
  };

  const convertHtml = (html) => {
    return html
      ?.replaceAll("&nbsp;", " ")
      ?.replaceAll("<div><div>", "\n")
      ?.replaceAll("<div>", "")
      ?.replaceAll("</div><br>", "\n")
      ?.replaceAll("</div>", "\n")
      ?.replaceAll("<br>", "\n")
      ?.replaceAll("<br/>", "\n")
      ?.replaceAll("<br />", "\n")
      ?.replaceAll("&#39;", "'")
      ?.replaceAll("<p>", "")
      ?.replaceAll("</p>", "");
  };

  const handleSendEmail = (appName, email_body, email_body_storage, templateSubject) => {
    const data = proposalData || values;
    const recipient = [
      data?.project_contact_1_email,
      data?.project_contact_2_email,
      data?.project_contact_3_email,
      data?.project_contact_4_email,
    ].filter((email) => email);

    const recipientNames = [
      data?.project_contact_1_name,
      data?.project_contact_2_name,
      data?.project_contact_3_name,
      data?.project_contact_4_name,
    ]
      .filter((name) => name)
      .map((fullName) => {
        const names = fullName.split(" ");
        return names[0];
      });

    const namesForMail = [...recipientNames];
    let composeGreeting = "Hi";
    if (namesForMail.length === 1) {
      composeGreeting += ` ${namesForMail[0]},`;
    } else if (namesForMail.length === 2) {
      composeGreeting += ` ${namesForMail[0]} and ${namesForMail[1]},`;
    } else if (namesForMail.length > 2) {
      const last = namesForMail.pop();
      composeGreeting += ` ${namesForMail.join(", ")}, and ${last},`;
    }

    const message = decodeHtmlEntities(convertHtml(email_body));
    const subject = decodeHtmlEntities(templateSubject || "");
    const body = decodeHtmlEntities(`${message.includes('Hi') ? '' : composeGreeting+'\n\n'}${message}\n\n${
      profile?.proposal_point_contact_name
    }\n${profile?.proposal_point_contact_phone}\n${
      profile?.proposal_point_contact_email
    }\n\n${profile?.company_name && profile?.company_name + "\n"}${
      profile?.company_street && profile?.company_street + "\n"
    }${profile?.company_city ? profile?.company_city + ", " : ""}${
      profile?.company_state
    } ${profile?.company_zip}`);
    const simple_body = decodeHtmlEntities(`${composeGreeting}\n\n${message}`);

    // Mailto link for default mail client
    const defaultMailLink = `mailto:${recipient}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    // Gmail link
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    // Outlook link
    const outlookLink = `https://outlook.office.com/owa/?path=/mail/action/compose&to=${recipient}&subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(simple_body)}`;

    // Yahoo Mail link
    const yahooLink = `https://compose.mail.yahoo.com/?to=${recipient}&subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(simple_body)}`;

    switch (appName) {
      case "gmail":
        window.open(gmailLink, "_blank");
        break;
      case "yahoo":
        window.open(yahooLink, "_blank");
        break;
      case "outlook":
        window.open(outlookLink, "_blank");
        break;
      case "default":
        window.open(defaultMailLink, "_blank");
        break;
    }

    const today = new Date().toISOString();
    const recipientMerge = paintProposalRecipientMergeFirstNames(data);
    const bodyForActivity =
      email_body_storage ??
      stripEmailTemplateMergeFields(email_body, {
        projectName: data?.project_name || "",
        companyNameMerge: data?.accountant_name || values?.accountant_name || "",
        prospectCompanyName: data?.customer_company_name || values?.customer_company_name || "",
        recipientFirstName: recipientMerge,
        yourName: profile?.first_name ?? "",
      });
    for (let rec in recipient) {
      dispatch(
        updateContactLastDateByName(
          today.slice(0, 16),
          recipient[rec],
          '',
          email_body,
          recipientNames[rec]
        )
      );
    }
    dispatch(updateProjectContactLastDateByName(today.slice(0, 16), data?.project_name));
    const proposalID = proposalData?.id || values?.id;
    const proposalName = `${proposalData?.project_name || values?.project_name}_${values?.bid_amount}_Paint Proposal`
    proposalID
      ? dispatch(downloadPaintProposal(proposalID, proposalName))
      : dispatch(handleDownload(null, proposalId, values));
  };

  return (
    <div className="bg-white ">
      <Container>
        <Row className="justify-content-end">
          <Col md={6}>
            <FontAwesomeIcon
              size={"2x"}
              icon={isFavorite ? solidStar : regularStar}
              style={{
                color: isFavorite ? "gold" : "transparent",
                stroke: isFavorite ? "" : "gold",
                strokeWidth: isFavorite ? "0" : "20",
                cursor: "pointer",
              }}
              onClick={handleFavoriteToggle}
              className="fw-bolder align-self-center my-4"
            />
          </Col>
        </Row>
        <StyledRow>
          <Col xs={12} md={12} className="my-proposal-col">
            <div className="mb-3 d-flex justify-content-end">
              <TradeDropdown
                selectedTrade={profile?.trade || 'cleaning'}
                onTradeChange={handleTradeChange}
                loading={loading}
              />
            </div>
            <StyledTabs
              activeKey={showTab}
              onSelect={showFormTab}
              transition={true}
              id="noanim-tab-example"
              className="mb-3"
            >
              <Tab
                eventKey="new"
                title="+"
                style={{ background: "blue", color: "white" }}
              />
              <Tab
                eventKey="home"
                title={
                  values?.project_name
                    ? values.project_name
                    : "Create New Proposal"
                }
                className="text-uppercase"
              >
                <Row>
                  <StyledSectionTwo className="col-sm-8 py-4 px-4">
                    <StyledPreviewText className="text-start">
                      Preview Section
                    </StyledPreviewText>
                    <div style={{ textTransform: "none" }}>
                      <ProposalPreviewForm />
                      <div className="text-center row mb-5 m-4 justify-content-center">
                        {isMobile ? (
                          <>
                            <Button
                              onClick={() => setProposalPreviewModal(true)}
                              className="me-5 col-md-3 "
                              disabled={downloader}
                            >
                              <h4>Preview</h4>
                            </Button>
                          </>
                        ) : (
                          <>
                            <div className="text-center"></div>
                            <Button
                              onClick={() => setProposalPreviewModal(true)}
                              className="me-5  col-md-2"
                            >
                              <h4> Preview</h4>
                            </Button>
                          </>
                        )}
                        {user &&
                          (isMobile ? (
                            <>
                              <Button
                                className="btn-success"
                                style={{ color: "#fff" }}
                                onClick={(e) =>
                                  handleDownload(e, values?.id, values?.project_name)
                                }
                                disabled={downloader || createLoader}
                              >
                                <h4>
                                  Download{" "}
                                  {downloader ||
                                    (createLoader && (
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    ))}
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>{" "}
                                </h4>
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                className="btn-success  col-md-2 "
                                style={{ color: "#fff" }}
                                onClick={(e) =>
                                  handleDownload(e, values?.id, values?.project_name)
                                }
                                disabled={downloader || createLoader}
                              >
                                <h4>
                                  Download{" "}
                                  {downloader ||
                                    (createLoader && (
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    ))}
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>{" "}
                                </h4>
                              </Button>
                            </>
                          ))}
                          {user?.company_name && (
                            <Button
                              className="btn-secondary ms-5 col-md-2"
                              style={{ color: "#fff" }}
                              onClick={(e) => {
                                if (!user?.id) {
                                  localStorage.setItem(
                                    "proposal",
                                    JSON.stringify(values)
                                  );
                                  setModalShow(true);
                                } else {
                                  setEmailModalShow(true);
                                  setProposalData(null);
                                }
                              }}
                            >
                              <h4>Email Proposal</h4>
                            </Button>
                          )}
                      </div>
                    </div>
                  </StyledSectionTwo>
                  <div className="col-sm-4">
                    <ProposalForm
                      setModalShow={setModalShow}
                      setPaymentModalShow={setPaymentModalShow}
                      setShowTab={setShowTab}
                    />
                  </div>
                </Row>
              </Tab>
              <Tab eventKey="recent" title="Saved Proposals">
                <RecentPaintProposal
                  setModalShow={setModalShow}
                  showFormTab={showFormTab}
                  showEmailPopup={(proposal) => {
                    setEmailModalShow(true);
                    setProposalData(proposal);
                  }}
                />
              </Tab>
              <Tab 
                eventKey='create_deal' 
                title={
                  <span>
                    Deal-Based Proposal{" "}
                    <OverlayTrigger
                      placement="right"
                      overlay={<Tooltip>Scope and pricing improved using deal data.</Tooltip>}
                    >
                      <InfoCircle style={{ cursor: "pointer", marginLeft: "5px" }} />
                    </OverlayTrigger>
                  </span>
                }
              />
            </StyledTabs>
          </Col>
        </StyledRow>
      </Container>
      <LoginModal show={modalShow} onHide={() => setModalShow(false)} />
      <SubscriptionModal
        show={paymentModalShow}
        onHide={() => setPaymentModalShow(false)}
      />
      <ProposalPreviewModal
        show={proposalPreviewModal}
        onHide={setProposalPreviewModal}
      />
      <EmailModal
        app="proposal"
        projectName={proposalData?.project_name || values?.project_name || ""}
        accountant_name={proposalData?.accountant_name || values?.accountant_name || ""}
        prospect_company_name={proposalData?.customer_company_name || values?.customer_company_name || ""}
        recipientFirstName={paintProposalRecipientMergeFirstNames(proposalData || values)}
        show={emailModalShow}
        closeOnOutsideClick={true}
        onHide={() => {
          setEmailModalShow(false);
          setProposalData(null);
        }}
        onChange={handleSendEmail}
        emailTemplates={userEditableTemplates}
        onSaveTemplate={(templateKey, body, name) => {
          saveUserEditableTemplateAPI(templateKey, body, name)
            .then(() => toastSuccess("Template saved"))
            .catch(() => toastError("Failed to save template"));
        }}
      />
    </div>
  );
};

export default PaintDocumentGenerator;
